import { Component } from '@angular/core';

@Component({
    selector: 'app-inactive-page',
    templateUrl: './inactive-page.component.html',
    styleUrls: ['./inactive-page.component.scss'],
    standalone: false
})
export class InactivePageComponent {

}
